import React from 'react'
import { t } from 'ttag'

import { JobDetails } from './details/JobDetails/JobDetails'
import { Interviews } from './tabs/Interviews/Interviews'
import { Jobs } from './tabs/Jobs/Jobs'
import { Messages } from './tabs/Messages/Messages'

import {
  DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS,
  DEFAULT_JOB_TEMPLATES_QUERY_PARAMS,
  DEFAULT_MESSAGE_TEMPLATES_QUERY_PARAMS,
} from 'constants/templates'
import { InterviewsPreview } from '../Interviews/InterviewsPreview'

const INTERVIEWS = 'interviews'
const JOBS = 'jobs'
const MESSAGES = 'messages'

export const TAB_NAMES = { INTERVIEWS, JOBS, MESSAGES }

export const getDefaultQueryParams = state => {
  const { tab } = state

  const queryParams = {
    [TAB_NAMES.JOBS]: DEFAULT_JOB_TEMPLATES_QUERY_PARAMS,
    [TAB_NAMES.INTERVIEWS]: DEFAULT_INTERVIEW_TEMPLATES_QUERY_PARAMS,
    [TAB_NAMES.MESSAGES]: DEFAULT_MESSAGE_TEMPLATES_QUERY_PARAMS,
  }

  return queryParams[tab]
}

export const getTabs = () => [
  { id: TAB_NAMES.INTERVIEWS, label: t`Interviews`, adminOnly: false },
  { id: TAB_NAMES.JOBS, label: t`Jobs`, adminOnly: false },
  { id: TAB_NAMES.MESSAGES, label: t`Messages`, adminOnly: true },
]

export const getDetails = state => {
  const { tab } = state

  const details = {
    [TAB_NAMES.JOBS]: <JobDetails />,
    [TAB_NAMES.INTERVIEWS]: <InterviewsPreview />,
    [TAB_NAMES.MESSAGES]: null,
  }

  return details[tab]
}

export const getTab = state => {
  const { tab } = state

  const tabs = {
    [TAB_NAMES.JOBS]: <Jobs />,
    [TAB_NAMES.INTERVIEWS]: <Interviews />,
    [TAB_NAMES.MESSAGES]: <Messages />,
  }

  return tabs[tab]
}
